import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {RightOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import { Button, Form} from 'antd'
import PhoneInput from 'antd-phone-input';
import dayjs from 'dayjs';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {geos} from '../../config/geo';
import {REGISTRATION} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {
    createGetMoneyWwCode,
    createGetMoneyWwCodeVariables
} from '../../shared/graphql/__generated__/createGetMoneyWwCode';
import {CREATE_CODE} from '../../shared/graphql/createGetMoneyKzCode';
import {phoneFormat} from '../../shared/helpers/phoneFormat';

import cls from '../registration/Registration.module.scss'

interface IFormValues {
    phone: string;
}

interface IForm {

    onComplete: (values: IFormValues) => void

}

export const LoginForm = observer(({onComplete}: IForm) => {

    const {t} = useTranslation();
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const {auth, geo} = useInstance(Store)

    const [time, setTime] = useState(Date.now());
    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const awaitSeconds = dayjs(auth.SendingDate).diff(dayjs().add(-5, 'minutes'), 'seconds')
    console.log(time)

    const [createCode] = useMutation<createGetMoneyWwCode, createGetMoneyWwCodeVariables>(CREATE_CODE)

    const onFinish = async (values: IFormValues) => {
        await createCode({
            variables: {
                phone: phoneFormat(values.phone),
                data: {},
            },
            onCompleted: () => {
                auth.setData(null, phoneFormat(values.phone), dayjs().format(), null)
                onComplete(values)
            },
            onError: (error) => {
                if (error.message === 'Unknown phone number') {
                    navigate(REGISTRATION)
                }
                if (error.message === 'Await') {
                    auth.setData(null, phoneFormat(values.phone), dayjs().format(), null)
                }
            }
        })
    }

    // @ts-ignore
    const validator = (_, {valid}) => {
        // if (valid(true)) return Promise.resolve(); // strict validation
        if (valid(true)) return Promise.resolve(); // non-strict validation
        return Promise.reject(t('Invalid format'));
    }

    return (
        <Form form={form} layout={'vertical'} size={'large'} validateTrigger={'onSubmit'} onFinish={onFinish}
              className={cls.form}>

            <Form.Item name={'phone'} label={t('Phone number')} validateFirst rules={[
                {required: true, message: t('Please fill in')!},
                {validator},
            ]}
                // validateStatus={errorUniqyePhone ? 'error' : undefined} help={errorUniqyePhone && 'Такой номер уже занят'}
            >
                <PhoneInput enableSearch preferredCountries={_.map(geos, item => item.name.toLowerCase())} country={geo.geo!.toLowerCase()}/>
            </Form.Item>


            {awaitSeconds > 0 &&
                <Form.Item>
                    {t('Resend via')} {Math.floor(awaitSeconds/60)}:{awaitSeconds%60}
                </Form.Item>
            }

            <Form.Item>
                <Button type={'primary'} htmlType={'submit'} icon={<RightOutlined/>}>{t('Get code')}</Button>
            </Form.Item>

        </Form>
    )

})